import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfSwiperTab from '@elem/ui/ef-swiper-tab';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const { locale = 'mx' } = useRouter();


    const configs = {
        navigation: false,
        hasInfo: true,
        gap: 0,
        lists: [
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1775285217535/8-pc-1.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1775285217164/8-m-1.jpg',
                tab: t('D_item1_tab'),
                title: t.rich('D_item1_title', {
                    b: (tx: string) => <span className="b">{tx}</span>,
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                }),
                desc: t('D_item1_desc'),

            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1775285218655/8-pc-3.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1775285217727/8-m-3.jpg',
                tab: t('D_item2_tab'),
                title: t.rich('D_item2_title', {
                    b: (tx: string) => <span className="b">{tx}</span>,
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                }),
                desc: t('D_item2_desc'),
                linkUrl: `https://${locale}.ecoflow.com/products/800w-alternator-charger`,
                linkText: t('D_btn'),
            },
            {

                pc: 'https://websiteoss.ecoflow.com/upload/image/1775285218842/8-pc-2.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1775285217337/8-m-2.jpg',
                tab: t('D_item3_tab'),
                title: t.rich('D_item3_title', {
                    b: (tx: string) => <span className="b">{tx}</span>,
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                }),
                desc: t('D_item3_desc'),
            },
        ],
        callback: () => { },
    };

    return (
        <div className={`${styles.TheComp} GtmModuleData-section`} data-section-id="D3-D" id='D3-D'>
            <EfSpec className="spec-m" />
            <EfSwiperTab {...configs} />
            {/* <EfSpec className="spec-x" /> */}
        </div>
    );
}
